var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-button-container"},[_c(_vm.component,_vm._g({tag:"component",staticClass:"base-button",class:[
      _vm.colorClass,
      {'button-primary--is-disabled' : _vm.disabled},
      {'base-button--is-delayed-hover' : _vm.delayHover},
      {'base-button--is-hover' : _vm.isHover}
    ],attrs:{"to":_vm.route,"type":_vm.buttonType}},_vm.inputListeners),[_c('span',{staticClass:"base-button__text",class:[_vm.textColorClass]},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b286c1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseButton/BaseButton.vue
// module id = null
// module chunks = 